import type { ReactNode } from "react";
import { ForbiddenError } from "@/api/client";
import { useAuth, type Action } from "@/providers/auth-provider";

/**
 * Render-blocking route guard. Throwing ForbiddenError during render lets the
 * route's RouteErrorBoundary catch it and show the styled Access Denied inside
 * the layout — the same path a backend 403 takes via React Query throwOnError.
 */
export function RequireAction({ action, children }: { action: Action; children: ReactNode }) {
  const { can } = useAuth();
  if (!can(action)) throw new ForbiddenError();
  return <>{children}</>;
}
